// extracted by mini-css-extract-plugin
export var blogCard = "post-link-module--blog-card--HDmXb";
export var blogLink = "post-link-module--blog-link--hdNfU";
export var blogCardTitle = "post-link-module--blog-card-title--f7e7c";
export var blogCardDate = "post-link-module--blog-card-date--RD6LK";
export var blogCardExcerpt = "post-link-module--blog-card-excerpt--Rz9mJ";